import { useEffect, useState, useCallback, useMemo, useContext } from "react";
import { WizardPage } from "@xengage/gw-portals-wizard-react";
import messages from '../PARentedTrailerCamper/PARentedTrailerCamperPolChange.messages';
import metadata from './PARentedTrailerCamperPolChange.metadata.json5';
import { useTranslator } from "@jutro/locale";
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from "@xengage/gw-portals-viewmodel-react";
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MLPolicyChangeDataHolderService, MLNavigationStepsTrackingService } from 'ml-services-common-react'; import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLEndorsementFlowUtil, MLEndorsementUtil } from 'ml-portals-util-js';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import _ from "lodash";

function PARentedTrailerCamperPolChange(props) {
    const { wizardData, updateWizardData, currentStep, goNext, currentStepIndex, changeNextSteps, steps } = props;
    const { onValidate, isComponentValid } = useValidation('PARentedTrailerCamperPolChange');
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();
    const { EndorsementService } = useDependencies('EndorsementService');
    const viewModelService = useContext(ViewModelServiceContext);
    const submissionVM = wizardData?.submissionVM ?? wizardData;

    const dtoPath = 'edge.capabilities.policyjob.lob.personalauto.coverables.dto.RentedTrailerCamperDTOML';
    const [isAddOrReplace, setIsAddOrReplace] = useState(false);
    const [vehicleIdx, setVehicleIdx] = useState();
    const [selectedVehicle, setSelectedVehicle] = useState();
    const [showAddAdditionalInterestedParty, setShowAddAdditionalInterestedParty] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const [rentedTrailerCamperVM, setRentedTrailerCamperVM] = useState(() => {
        return viewModelService.create({}, 'pc', dtoPath);
    })
    const [isEditing, setIsEditing] = useState(false);

    const vehiclesVM = submissionVM?.lobData?.personalAuto?.coverables?.vehicles;
    const vehicles = Array.isArray(vehiclesVM?.value) ? vehiclesVM.value : [];
  
    const formatDate = ({ day, month, year }) => {
        const date = new Date(year, month, day)
        return date.toLocaleDateString('wn-GB')
    }

    const effectiveDatOfPolicy = submissionVM?.baseData?.policyStartDate_ML

    const editingTrailer = useMemo(() => {
        for (let i = 0; i < vehicles.length; i++) {
            const trailers = _.get(vehicles[i], 'rentedTrailerOrCamper_Ext', []);
            const trailer = trailers.find(t => _.get(t, 'isEditing') === true);
            if (trailer) {
                setIsEditing(true)
                return { trailer, vehicleIndex: i };
            }
        }
        return null;
    }, [vehicles]);

    useEffect(() => {
        if (MLPolicyChangeDataHolderService.getPageAction() === 'edit' && editingTrailer?.trailer) {
            const trailer = editingTrailer.trailer;
            const additionalInterests = trailer.additionalInterests ?? [];
            setShowAddAdditionalInterestedParty(Array.isArray(additionalInterests) && additionalInterests.length > 0);
            const trailerVM = viewModelService.create(trailer, 'pc', dtoPath);
            setVehicleIdx(editingTrailer.vehicleIndex);
            setRentedTrailerCamperVM(trailerVM);
        }
        else {
            setRentedTrailerCamperVM(
                viewModelService.create({}, 'pc', dtoPath)
            );
        }

    }, [editingTrailer, viewModelService, dtoPath]);


    const getVehicleValues = () => {
        const ppVehicle = vehicles.filter(v =>
            !(v.category_ML === "trailer_np" || v.category_ML === "camper_np")
        )
        return ppVehicle.map(v => ({
            code: v.fixedId,
            name: v.displayName || `${v.year} ${v.make} ${v.model}`
        }))
    };
    const vehicleOptions = getVehicleValues();

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        clearBlockAlerts,
        addErrorAlert,
        addWarningAlert,
        clearAlerts,
        addSuccessAlert,
        clearErrorAlerts
    } = MLNotificationBlockUtil();

    useEffect(() => {
        if (MLEndorsementFlowUtil.startingPointPageLoadIsSkipping(submissionVM, goNext, steps, currentStepIndex, changeNextSteps)) {
            return;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const initRentedTrailerCamperPage = useCallback(() => {
        const stepName = translator(messages.addRentedTrailerCamper);
        MLNavigationStepsTrackingService.addToDynamicSteps(
            stepName,
            !currentStep.existingStep,
            currentStep.mlStepName,
            authHeader
        );
    }, [translator, currentStep, authHeader]);

    const jumpToSelectedStepByStepID = useCallback((newStepID) => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, steps, currentStepIndex, changeNextSteps, goNext, productCode)
    }, [changeNextSteps, currentStepIndex, goNext, productCode, steps]);

    useEffect(() => {
        initRentedTrailerCamperPage();
    }, [currentStep, authHeader]);

    const validateExpirationDate = () => {
        const {
            rentedTrailerCamperEffectiveDate: effectiveDateInput,
            rentedTrailerCamperExpirationDate: expirationDateInput
        } = rentedTrailerCamperVM;

        const getValue = part =>
            _.isNumber(part?.value) ? part.value : part;

        const hasValidNumericValues = _.every(
            [effectiveDateInput, expirationDateInput],
            date =>
                _.every(
                    [
                        getValue(date.year),
                        getValue(date.month),
                        getValue(date.day)
                    ],
                    _.isNumber
                )
        );

        if (!hasValidNumericValues) return false;

        const effectiveDate = new Date(
            getValue(effectiveDateInput.year),
            getValue(effectiveDateInput.month),
            getValue(effectiveDateInput.day)
        );

        const expirationDate = new Date(
            getValue(expirationDateInput.year),
            getValue(expirationDateInput.month),
            getValue(expirationDateInput.day)
        );

        const policyEffectiveDate = new Date(
            getValue(effectiveDatOfPolicy.year),
            getValue(effectiveDatOfPolicy.month),
            getValue(effectiveDatOfPolicy.day)
        );

        const maxAllowedExpirationDate = new Date(effectiveDate);
        maxAllowedExpirationDate.setDate(
            maxAllowedExpirationDate.getDate() + 90
        );

        return (
            expirationDate > effectiveDate &&
            expirationDate<=maxAllowedExpirationDate
        );
    };

    const handleModelChange = useCallback((updatedModel) => {
        _.set(submissionVM, `lobData.personalAuto.coverables.vehicles.children[${vehicleIdx}].rentedTrailerOrCamper_Ext.value[0]`, updatedModel.value);

        updateWizardData(prev => ({ ...prev, submissionVM: submissionVM }));

    }, [updateWizardData]);

    const updateRentedTailerCamperVM = useCallback(() => {
        _.set(submissionVM, `lobData.personalAuto.coverables.vehicles.children[${vehicleIdx}].rentedTrailerOrCamper_Ext.value[0]`, rentedTrailerCamperVM.value);

        updateWizardData(submissionVM);
    }, [rentedTrailerCamperVM, updateWizardData, submissionVM]);

    const handleVehicleValueChange = useCallback((value, path) => {
        setSelectedVehicle(value);
        const vehicleIdx = _.findIndex(vehicles, v => v.fixedId == value);
        if (vehicleIdx !== -1) setVehicleIdx(vehicleIdx);
        _.set(rentedTrailerCamperVM, 'towingVehicleFixedId', value)
        _.set(vehiclesVM, `vehicles.children[${vehicleIdx}].rentedTrailerOrCamper_Ext.children[0]`, rentedTrailerCamperVM);
        updateWizardData(submissionVM)
    }, [rentedTrailerCamperVM, vehiclesVM]);

    const handleAdditionalInterestRadioBtnChange = useCallback((addIntoptions) => {
        const value = addIntoptions && typeof addIntoptions === 'object' ? addIntoptions.value : addIntoptions;
        setShowAddAdditionalInterestedParty(value);
        if (value === false && rentedTrailerCamperVM) {
            _.set(rentedTrailerCamperVM, 'additionalInterests.value', [])
            updateRentedTailerCamperVM();
        }
        refreshData();
    },
        [
            rentedTrailerCamperVM,
            updateWizardData,
            refreshData
        ]
    );

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const writeValue = useCallback((value, path) => {
        _.set(rentedTrailerCamperVM, path, value);
    }, [rentedTrailerCamperVM]);

    const additionalInterestWriteValue = useCallback((value, path) => {
        path = path.substr(1);
        _.set(rentedTrailerCamperVM, path, value);
        updateRentedTailerCamperVM();
        refreshData();
    }, [refreshData, rentedTrailerCamperVM]);

    const navigateAfterSave = () => {
        clearAlerts();
        if (isAddOrReplace) {
            const action = 'Add';
            MLTagManagerService.sendFormStepPolicyChangeStep(`${action} Vehicle`);
            MLPolicyChangeDataHolderService.setPageAction('requote');
            jumpToSelectedStepByStepID("endorsementPaRentedTrailerCamperPolChange");
        } else {
            MLTagManagerService.sendFormStepPolicyChangeStep(`Edit Vehicle`);
            jumpToSelectedStepByStepID("endorsementAdditionalChanges");
        }
    };

    const syncAndSave = () => {
        const item = rentedTrailerCamperVM;
        submissionVM.value.portalCurrentStep_ML = currentStep.mlStepName;
        const savePromise = EndorsementService.saveEndorsement([submissionVM.value], authHeader)
        showProgressDialog(messages.save, savePromise);
        savePromise.then((pc) => {
            const policyChange = new PolicyChange(Object.assign({}, pc));
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');
            const details = {
                data: `${item.year?.value ? item.year.value : item.year}
                ${item.make?.value ? item.make.value : item.make}
                ${item.model?.value ? item.model.value : item.model}`,
                pageAction: MLPolicyChangeDataHolderService.getPageAction()
            };
            MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader);
            updateWizardSubmissionData(updatedEndorsementVM);
            const lbl = MLEndorsementUtil.stepLabel(currentStep);
            MLEndorsementUtil.setEndorsementDescription(lbl, updatedEndorsementVM, translator);
            navigateAfterSave();
        })
    }

  const onNext = useCallback(async () => {
        if (!isComponentValid) {
            setShowErrors(true);
            return;
        }
        const isValid = validateExpirationDate();
        if (!isValid) {
            clearAlerts();
            addErrorAlert(translator(messages.expirationDateInputErrorMessage))
            return;
        }
        syncAndSave();
    }, [EndorsementService, authHeader, submissionVM, isComponentValid, updateWizardData]);

    const basePath = 'lobData.personalAuto.coverables';
    const overrideProps = useMemo(() => {
        return {
            vehicleSelect: {
                availableValues: vehicleOptions,
                onValueChange: handleVehicleValueChange,
                required: true,
                disabled: isEditing
            },
            additionalInterestField: {
                onValueChange: handleAdditionalInterestRadioBtnChange,
                value: showAddAdditionalInterestedParty,
            },
            additionalInterestListContainer: {
                visible: showAddAdditionalInterestedParty && !_.isNil(vehicleIdx) && rentedTrailerCamperVM,
            },
            additionalInterestList: {
                updateViewModel: updateRentedTailerCamperVM,
                model: _.get(rentedTrailerCamperVM, 'additionalInterests', []),
                onValueChange: additionalInterestWriteValue,
                submissionVM,
                path: `${basePath}.vehicles.children[${vehicleIdx}].rentedTrailerOrCamper_Ext.children[0]`,
                isPersonalUmbrella: false,
                showValidationErrors: showErrors,
                onValidate
            },
            rentedTrailerCamperExpirationDate: {
                onValidate
            },
            rentedTrailerCamperYearInput: {
                disabled: isEditing
            },
            rentedTrailerCamperMakeInput: {
                disabled: isEditing
            },
            rentedTrailerCamperModelInput : {
                disabled: isEditing
            },


        };
    },);

    const resolvers = {
        resolveCallbackMap: {
            onNext: onNext
        }
    };

    return (
        <WizardPage showCancel={false} showPrevious={false} showNext={false}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={rentedTrailerCamperVM}
                onModelChange={handleModelChange}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                showErrors={showErrors}
            />
        </WizardPage>
    );
}

export default PARentedTrailerCamperPolChange;